module.exports = __webpack_public_path__ + "media/images/our_apps/tablet_md-16b261af9c6dd2618d78b661cd506c2c.png";